// extracted by mini-css-extract-plugin
module.exports = {"inner":"Profiles_inner__1j6jt","profilesContainer":"Profiles_profilesContainer__30s-d"};